export const IconFacebook = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="12" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.1991 40V27.9986H34.1436L34.6663 23.8628H30.1991L30.2058 21.7929C30.2058 20.7142 30.3278 20.1362 32.1725 20.1362H34.6384V16H30.6933C25.9547 16 24.2868 18.0063 24.2868 21.3802V23.8633H21.333V27.9991H24.2868V40H30.1991Z"
      fill="white"
    />
  </svg>
);
